const FileHelpers = {
  // https://codezup.com/convert-pdf-file-to-base64-encoding-in-react/
  async fileToBase64(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  },
  getFilenameFromAxiosResponse(response) {
    let headerLine = response.headers["content-disposition"];
    let startFileNameIndex = headerLine.indexOf('"') + 1;
    let endFileNameIndex = headerLine.lastIndexOf('"');
    let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
    return filename;
  },
};

export { FileHelpers };
